import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Canvas as CanvasComponent } from '../components/Canvas';
import { COLORS } from '../styles';

const EDITOR_RESET_STYLES = css`
  font-family: 'Noto Sans KR', 'Apple SD Gothic Neo', '맑은 고딕',
    'Malgun Gothic', sans-serif;
  * {
    box-sizing: border-box;
    &[hidden] {
      display: block;
    }
  }
`;

export const Container = styled.div`
  ${EDITOR_RESET_STYLES};
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid ${COLORS.slategray20};
    z-index: 1;
    pointer-events: none;
  }
`;

export const Header = styled.div`
  position: relative;
  z-index: 1;
`;

export const Body = styled.div`
  overflow: hidden;
  flex: 1;
  display: flex;
  width: 100%;
`;

export const Canvas = styled(CanvasComponent)`
  position: relative;
  flex: 1 0 0px;
  z-index: 0;
`;

export const Sider = styled.div<{ width?: number }>`
  position: relative;
  display: flex;
  flex-direction: row;
  min-width: 150px;
  ${({ width }) => (width ? `width: ${width}px;` : 'width: 250px;')}
  box-shadow: 0 0 0 1px ${COLORS.slategray10};
  background: ${COLORS.gray0};
  z-index: 1;
`;

export const Resizer = styled.div<{ left?: boolean, right?: boolean }>`
  z-index: 1;
  position: absolute;
  top: 0;
  bottom: 0;
  ${({ left }) => left && 'left: -2px;'}
  ${({ right }) => right && 'right: -2px;'}
  width: 4px;
  cursor: col-resize;
  z-index: 1;
  &:hover,
  &:active {
    background: ${COLORS.slategray20};
  }
`;

export const Panel = styled.div`
  overflow-y: auto;
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  box-shadow: 0 -1px 0 0 ${COLORS.gray30};
  &:first-of-type {
    box-shadow: none;
  }
`;
